import Notification from './Notification';
export default Notification;


//////////////////
// WEBPACK FOOTER
// ../~/rc-notification/es/index.js
// module id = 2679
// module chunks = 1